import { useState } from 'react';
import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import AppSidebar from './sidebar/sidebar.component';
import AppHeader from './header/header.component';
import { NavLinkType } from '../../type/navlink.types';
import {
  Home,
  List,
  Link,
  Book,
  History,
  Users,
  FileReport,
} from 'tabler-icons-react';
import { Helmet } from 'react-helmet';

const MerchantBranchesDashboardLayout = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const navLinkProps: NavLinkType[] = [
    {
      order: 1,
      link: '/branches/dashboard',
      label: 'Dashboard',
      icon: Home,
    },
    {
      order: 2,
      link: '/branches/create-payment-links',
      label: 'Payment Links',
      icon: Link,
    },
    {
      order: 3,
      link: '/branches/transactions',
      label: 'Transactions',
      icon: FileReport,
    },
    {
      order: 4,
      link: '/branches/logs',
      label: 'Logs',
      icon: History,
    },
    {
      order: 5,
      link: '/branches/users',
      label: 'User Management',
      icon: Users,
    },
  ];

  return (
    <>
      <Helmet>
        <title>XPAY.World - Merchant Branch Dashboard</title>
      </Helmet>
      ;
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <AppShell
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
              '@media (max-width: 992px)': {
                paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
              },
            },
          }}
          navbarOffsetBreakpoint='md'
          asideOffsetBreakpoint='md'
          fixed
          navbar={<AppSidebar navLinkProps={navLinkProps} opened={opened} />}
          header={<AppHeader opened={opened} setOpened={setOpened} />}
        >
          <Outlet />
        </AppShell>
      </MantineProvider>
    </>
  );
};

export default MerchantBranchesDashboardLayout;
